import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-recommend-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonHorizontalRecipeList = _resolveComponent("CommonHorizontalRecipeList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_CommonHorizontalRecipeList, {
      class: "pantry-recommend-view-recommend-area",
      recipes: _ctx.recipes,
      onOnClick: _ctx.selectRecipe
    }, null, 8, ["recipes", "onOnClick"])
  ]))
}